import { Component, OnInit } from '@angular/core';
import { OfbizForm, OfbizList, RemoteFormData, LookupCombo, Lookup, LOOKUPS } from '@urbannex/ofbiz-forms';

@Component({
  selector: 'ngx-lookup-entity',
  templateUrl: './lookup-entity.component.html',
  styleUrl: './lookup-entity.component.scss'
})
export class LookupEntityComponent implements OnInit {
  entityType: string;
  title: string;
  productRemoteFormData: RemoteFormData = {
    formData: {
      formName: "ListProductCategoryMembers",
      formLocation: "component://kwikstore/widget/ProductForms.xml",
      listType: "grid",
      entityName: "",
      viewIndex: 0,
      viewSize: 20
    },
    parameters: { "productCategoryId": "CATALOG1_SEARCH" }
  }
  articleRemoteFormData: RemoteFormData = {
    formData: {
      formName: '',
      formLocation: '',
      listType: '',
      entityName: '',
      viewIndex: 0,
      viewSize: 0
    }
  }
  categoryRemoteFormData: RemoteFormData = {
    formData: {
      formName: '',
      formLocation: '',
      listType: '',
      entityName: '',
      viewIndex: 0,
      viewSize: 0
    }
  }
  /**
     * FindForms used to search for entities on the backend
     */
  findForm: OfbizForm;
  /**
   * ListForm to display the search results
   */
  listForm: OfbizList;
  /**
   * List of lookups found in the componentConfig
   */
  lookups: Lookup[] = [];
  /**
   *
   */
  lookup: Lookup;
  /**
   * Combination of lookup form and result list
   * Used if lookups are not used
   */
  lookupCombo: LookupCombo;

  constructor() {

  }

  ngOnInit(): void {
    if (this.entityType) {
      console.log("Entity type " + this.entityType)
      switch (this.entityType) {
        case 'product':
          this.title = "Select Product";
          this.lookupCombo = LOOKUPS.find(lu => lu.fieldFormName == 'LookupProduct');
          break;
        case 'category':
          this.title = "Select Category";
          this.lookupCombo = LOOKUPS.find(lu => lu.fieldFormName == 'LookupProduct');
          break;
        case 'article':
          this.title = "Select Article";
          this.lookupCombo = LOOKUPS.find(lu => lu.fieldFormName == 'LookupProduct');
          break;
        default:
          break;
      }
      if (this.lookupCombo) {
        console.log({ "lookupForm": this.lookupCombo.lookupForm, "lookupList": this.lookupCombo.lookupList })
        this.findForm = this.lookupCombo.lookupForm;
        this.listForm = this.lookupCombo.lookupList;
        console.log({ "findForm": this.findForm, "listForm": this.listForm })
      } else {
        console.log("Lookup combo not found for entity type " + this.entityType)
      }
    }
  }

  close() {

  }
}
